// extracted by mini-css-extract-plugin
export default {"contentInner":"styles-module__lgjIp","modal":"styles-module__L3xEv"};